export enum FontWeightEnum {
  Bold = 700,
  SemiBold = 600,
  Medium = 500,
  Regular = 400,
}
